/**
 * Single place that trims offer-list filter strings.
 * Call at the URL / input boundary; pass the result through the rest of the list flow as-is.
 */
export function normalizeOffersFilters({ query, restaurantId } = {}) {
	return {
		query: (query || "").trim(),
		restaurantId: (restaurantId || "").trim(),
	};
}

/**
 * React Router 6 stores a session index on history.state.idx.
 * idx === 0 (or missing) means this is the first entry of the session
 * (deep link / refresh), so navigate(-1) may leave the app.
 */
export function canGoBackInSession() {
	return (window.history.state?.idx ?? 0) > 0;
}

/**
 * Stable key for the active list filters (search text + restaurant scope).
 * Used to drop stale responses and decide when cached rows still apply.
 * Expects already-normalized arguments.
 */
export function buildOffersFilterKey(...args) {
	return JSON.stringify(args);
}

export function buildRestaurantDropdownOptions(restaurants) {
	if(!restaurants || restaurants.length === 0) return [];
	const options = [{ head: "All restaurants", value: "" }];
	(restaurants).forEach((restaurant) => {
		if (!restaurant._id) return;
		options.push({
			head: restaurant._id,
			value: restaurant._id,
		});
	});
	return options;
}

